const amountComponentContainer = () => {
  return {
    restrict: "E",
    template: require("./template.html"),
    transclude: true,
  };
};

angular
  .module("avant.customer_applications.directives")
  .directive("amountComponentContainer", amountComponentContainer);
